import axios from 'axios'
import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success } from '../../shared/constants'

export const useCompanyConfig = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [loggedUser, setLoggedUser] = useState(false)
  const [loading, setLoading] = useState(false)
  //console.log('loggedUser : ', loggedUser)
  const getLoggedInUser = async () => {
    setLoading(true)
    axios
      .post(API.GET_LOGGED_IN_USER, { userId: user && user.user._id }, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data.data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoggedUser(data.data)
        // setCompanyConfigs(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const updateCompanyConfig = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .put(API.UPDATE_COMPANY_ADMIN, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Company Information Updated Successfully', success)
        localStorage.setItem('company', JSON.stringify(data.data))

        // addNewCompanyConfig(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateCompanyPersonalInfo = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .put(API.UPDATE_COMPANY_ADMIN_PERSONAL_INFO, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Personal Information Updated Successfully', success)
        // addNewCompanyConfig(data.data)
        localStorage.setItem('company', JSON.stringify(data.data))
        const user = {
          _id: data.data._id,
          name: data.data.firstName,
          userType: data.data.userType,
          profilePicture: data.data.profilePicture,
          alllowedFeatures: data.data.allowedFeatures,
          loginTime: Date.now(),
        }

        localStorage.setItem('user', JSON.stringify(user))
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const updateCompanyAccount = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .put(API.UPDATE_COMPANY_ADMIN_SETTING, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Account Setting Updated Successfully', success)
        localStorage.setItem('company', JSON.stringify(data.data))

        // addNewCompanyConfig(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    // addCompanyConfig,
    getLoggedInUser,
    loggedUser,
    updateCompanyConfig,
    updateCompanyPersonalInfo,
    updateCompanyAccount,
    loading,
  }
}
